export const Credits = ({
  variant = 'free',
  theme = 'dark',
  ...props
}: React.JSX.IntrinsicAttributes &
  React.SVGProps<SVGSVGElement> & {
    variant?:
      | 'currentColor'
      | 'submitButton'
      | 'free'
      | 'standard_v2'
      | 'premium_v2'
      | 'ultimate_v2'
      | 'purchaseCredits'
      | 'team_v2';
    theme?: 'light' | 'dark';
  }) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM14.8571 9.14286C12.8929 7.17857 12 3.42857 12 3.42857C12 3.42857 11.1071 7.17857 9.14286 9.14286C7.17857 11.1071 3.42857 12 3.42857 12C3.42857 12 7.29018 13.0045 9.14286 14.8571C10.9955 16.7098 12 20.5714 12 20.5714C12 20.5714 12.7366 16.9777 14.8571 14.8571C16.9777 12.7366 20.5714 12 20.5714 12C20.5714 12 16.8214 11.1071 14.8571 9.14286Z"
      fill={variant === 'currentColor' ? 'currentColor' : `url(#${variant})`}
      fillRule="evenodd"
    />

    {variant !== 'currentColor' && (
      <defs>
        {variant === 'submitButton' && (
          <linearGradient id="submitButton" x1="0.5" y1="8" x2="23.5" y2="22" gradientUnits="userSpaceOnUse">
            <stop stopColor="#7A76FF" />
            <stop offset="1" stopColor="#2487F1" />
          </linearGradient>
        )}
        {variant === 'free' &&
          (theme === 'light' ? (
            <linearGradient
              id="free"
              gradientUnits="userSpaceOnUse"
              x1="1.4777e-07"
              x2="13.4167"
              y1="4.66667"
              y2="12.8333"
            >
              <stop offset="0.0001" stopColor="#33DDE5" />
              <stop offset="1" stopColor="#0F9CFF" />
            </linearGradient>
          ) : (
            <linearGradient id="free" gradientUnits="userSpaceOnUse" x1="2.5332e-07" x2="23" y1="8" y2="22">
              <stop offset="0.0001" stopColor="#33DDE5" />
              <stop offset="1" stopColor="#0F9CFF" />
            </linearGradient>
          ))}
        {variant === 'standard_v2' &&
          (theme === 'light' ? (
            <linearGradient id="standard_v2" gradientUnits="userSpaceOnUse" x1="14" x2="0" y1="7" y2="7">
              <stop stopColor="#6394FF" />
              <stop offset="1" stopColor="#98CCFF" />
            </linearGradient>
          ) : (
            <linearGradient id="standard_v2" gradientUnits="userSpaceOnUse" x1="24" x2="0" y1="12" y2="12">
              <stop stopColor="#78A3FF" />
              <stop offset="1" stopColor="#E5F2FF" />
            </linearGradient>
          ))}
        {variant === 'premium_v2' &&
          (theme === 'light' ? (
            <linearGradient id="premium_v2" gradientUnits="userSpaceOnUse" x1="14" x2="0" y1="7" y2="7">
              <stop stopColor="#DEAD49" />
              <stop offset="1" stopColor="#E7C98F" />
            </linearGradient>
          ) : (
            <linearGradient id="premium_v2" gradientUnits="userSpaceOnUse" x1="24" x2="0" y1="12" y2="12">
              <stop stopColor="#BA9D64" />
              <stop offset="1" stopColor="#FFF7D0" />
            </linearGradient>
          ))}
        {variant === 'ultimate_v2' &&
          (theme === 'light' ? (
            <linearGradient id="ultimate_v2" gradientUnits="userSpaceOnUse" x1="0" x2="14" y1="7" y2="7">
              <stop stopColor="#B6B9FF" />
              <stop offset="1" stopColor="#968DFF" />
            </linearGradient>
          ) : (
            <linearGradient id="ultimate_v2" gradientUnits="userSpaceOnUse" x1="0" x2="24" y1="12" y2="12">
              <stop stopColor="#EAEBFF" />
              <stop offset="1" stopColor="#877DFF" />
            </linearGradient>
          ))}

        {variant === 'team_v2' && (
          <linearGradient id="team_v2" x1="14" y1="7" x2="0" y2="7" gradientUnits="userSpaceOnUse">
            <stop stopColor="#15B8E6" />
            <stop offset="1" stopColor="#ABE9FF" />
          </linearGradient>
        )}
        {variant === 'purchaseCredits' && (
          <linearGradient id="purchaseCredits" gradientUnits="userSpaceOnUse" x1="24" x2="0" y1="12" y2="12">
            <stop offset="0.111111" stopColor="#94D8FF" />
            <stop offset="1" stopColor="#E0DDFF" />
          </linearGradient>
        )}
      </defs>
    )}
  </svg>
);
